import React from 'react';

const WA_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '919606209376';

const WA_ICON = (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

function waLink(serviceName) {
  const text = encodeURIComponent(`Hi KayaSparsha! I'd like to enquire about *${serviceName}*. Please share more details.`);
  return `https://wa.me/${WA_NUMBER}?text=${text}`;
}

const SERVICES = [
  {
    num: '01', icon: '🩺', name: 'Ayurvedic Consultation',
    desc: 'Personalised Nadi Pariksha (pulse diagnosis) and Prakriti analysis. First consultation includes a complete health assessment and treatment plan.',
    duration: 'First Visit'
  },
  {
    num: '02', icon: '🌊', name: 'Abhyanga Massage',
    desc: 'Full-body synchronised oil massage using warm medicated oils. Improves circulation, nourishes tissues, and calms the nervous system.',
    duration: '60 min'
  },
  {
    num: '03', icon: '💧', name: 'Shirodhara',
    desc: 'A continuous stream of warm oil on the forehead. Deeply effective for stress, insomnia, anxiety, and nervous system disorders.',
    duration: '45 min'
  },
  {
    num: '04', icon: '🔥', name: 'Panchakarma',
    desc: 'The complete Ayurvedic detoxification system. A personalised 7–21 day programme cleansing accumulated toxins and restoring dosha balance.',
    duration: '7–21 days'
  },
  {
    num: '05', icon: '🌾', name: 'Njavarakizhi',
    desc: 'Rejuvenating rice bolus massage — medicated rice cooked in milk and herbal decoctions, applied in cloth bundles to nourish and strengthen tissues.',
    duration: '60 min'
  },
  {
    num: '06', icon: '🧴', name: 'Ayurvedic Products',
    desc: 'Curated Triphala, Ashwagandha, Brahmi, Chyawanprash, healing oils and custom formulations prescribed by our doctors for at-home care.',
    duration: 'In-clinic pharmacy'
  }
];

export default function ServicesSection() {
  return (
    <section className="services" id="services">
      <div className="container">
        <div className="services-header">
          <div className="fade-up">
            <p className="section-label">What We Offer</p>
            <h2 className="section-title">Our Core <em>Services</em></h2>
          </div>
        </div>
        <div className="services-grid">
          {SERVICES.map((s) => (
            <div key={s.num} className="service-card fade-up">
              <div className="service-num">{s.num}</div>
              <div className="service-icon">{s.icon}</div>
              <h3 className="service-name">{s.name}</h3>
              <p className="service-desc">{s.desc}</p>
              <div className="service-footer">
                <a
                  href={waLink(s.name)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="service-wa-btn"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 6,
                    color: 'var(--gold)', textDecoration: 'none', fontSize: 12,
                    fontWeight: 600, letterSpacing: 0.5,
                  }}
                >
                  {WA_ICON} Enquire on WhatsApp
                </a>
                <span className="service-duration">{s.duration}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
